import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    isValid: false,
    expiryDate: null
};

class RailcardValidationResponse extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(RailcardValidationResponse, json, {
            expiryDate: fields.string,
            isValid: fields.bool
        });
    }
}

export default RailcardValidationResponse;
